export type TurnstileWidgetId = string | number;

interface TurnstileRenderOptions {
  sitekey: string;
  action: string;
  callback(token: string): void;
  "expired-callback"(): void;
}

interface TurnstileApi {
  render(selector: string, options: TurnstileRenderOptions): TurnstileWidgetId;
  reset(widgetId: TurnstileWidgetId): void;
  remove(widgetId: TurnstileWidgetId): void;
}

declare global {
  interface Window { turnstile?: TurnstileApi; }
}

let scriptPromise: Promise<TurnstileApi> | null = null;

export function loadTurnstile(): Promise<TurnstileApi> {
  if (window.turnstile) return Promise.resolve(window.turnstile);
  if (scriptPromise) return scriptPromise;
  scriptPromise = new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.src = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";
    script.async = true;
    script.onload = () => window.turnstile ? resolve(window.turnstile) : reject(new Error("Verification did not initialize."));
    script.onerror = () => reject(new Error("Verification could not load."));
    document.head.append(script);
  });
  return scriptPromise;
}
